<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_13_14477"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect
        width="16"
        height="16"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_13_14477)">
      <path
        d="M10.2002 11.1333L11.1335 10.2L8.66683 7.73333V4.66666H7.3335V8.26666L10.2002 11.1333ZM8.00016 14.6667C7.07794 14.6667 6.21127 14.4917 5.40016 14.1417C4.58905 13.7917 3.8835 13.3167 3.2835 12.7167C2.6835 12.1167 2.2085 11.4111 1.8585 10.6C1.5085 9.78888 1.3335 8.92222 1.3335 7.99999C1.3335 7.07777 1.5085 6.21111 1.8585 5.39999C2.2085 4.58888 2.6835 3.88333 3.2835 3.28333C3.8835 2.68333 4.58905 2.20833 5.40016 1.85833C6.21127 1.50833 7.07794 1.33333 8.00016 1.33333C8.92238 1.33333 9.78905 1.50833 10.6002 1.85833C11.4113 2.20833 12.1168 2.68333 12.7168 3.28333C13.3168 3.88333 13.7918 4.58888 14.1418 5.39999C14.4918 6.21111 14.6668 7.07777 14.6668 7.99999C14.6668 8.92222 14.4918 9.78888 14.1418 10.6C13.7918 11.4111 13.3168 12.1167 12.7168 12.7167C12.1168 13.3167 11.4113 13.7917 10.6002 14.1417C9.78905 14.4917 8.92238 14.6667 8.00016 14.6667Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 40
    },
    variant: {
      type: String,
      default: 'light' // light, dark
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return '#303030'
      }

      if (props.variant === 'light') {
        return '#e5e5e5'
      }

      if (props.variant === 'acent') {
        return '#db7f50'
      }

      // Default: light
      return '#e5e5e5'
    })()

    return {
      color,
    }
  }
})
</script>
